module.exports = __webpack_public_path__ + "img/Group 195.d3db5559.png";